<template lang="pug">
#ds-multiplos
    .ds-multiplos-card(
        :class='isCollapsed ? "width-30-percent" : "width-58-percent"',
        :style='{ padding: isCollapsed ? "20px 0px 20px 0px" : "20px 0px 20px 20px" }'
    )
        .ds-multiplos-card-header-2.ds-multiplos-card-header
            .ds-multiplos-card-header__titulo
                span {{ $t('mensagens.diagnosticoSocioambiental.titulo') }}
                span
                el-tooltip(
                    :content='isCollapsed ? $t("mensagens.diagnosticoSocioambiental.expandirDiagnostico") : $t("mensagens.diagnosticoSocioambiental.recuarDiagnostico")',
                    placement='top'
                )
                    i.arrow(
                        @click='toggleCollapse',
                        :class='isCollapsed ? "el-icon-arrow-right" : "el-icon-arrow-left"'
                    )

        #root-scroll.ds-multiplos-card--scroll
            .ds-multiplos-card-sub-titulo
                span {{ $t('mensagens.diagnosticoSocioambiental.utilizeCamposAbaixoParaRealizarDiagnostico') }}
            template.ds-multiplos-inputs(
                v-if='this.usuarioLogado.ambienteLogado === this.ambientes.PARAGUAY'
            )
                el-select(
                    v-model='departamentoSelecionado',
                    :loading='departamento.loading',
                    :placeholder='$t("mensagens.diagnosticoSocioambiental.propriedadesCamada.departamento")',
                    @change='listarLocalidadeNivelDois',
                    value-key='id',
                    clearable
                )
                    el-option(
                        v-for='item in departamento.lista',
                        :key='item.id',
                        :label='item.label',
                        :value='item'
                    )
                el-select(
                    :disabled='!departamentoSelecionado',
                    :loading='distrito.loading',
                    v-model='distritoSelecionado',
                    :placeholder='$t("mensagens.diagnosticoSocioambiental.propriedadesCamada.dist")',
                    clearable,
                    value-key='id'
                )
                    el-option(
                        v-for='item in distrito.lista',
                        :key='item.id',
                        :label='item.label',
                        :value='item'
                    )
                .ds-multiplos-card-campo-consulta
                    .ds-multiplos-card-campo-consulta__input
                        el-input(
                            :clearable='true',
                            @clear='consultaInvalida = false',
                            prefix-icon='el-icon-search',
                            type='text',
                            @keyup.enter.native='processamentoParaguai(consultaDiagnosticoSocioambiental)',
                            @keydown.tab.native='processamentoParaguai(consultaDiagnosticoSocioambiental)',
                            :placeholder='$t("mensagens.diagnosticoSocioambiental.pesquisaPlaceholderPY")',
                            maxLength='10',
                            style='width: 100%; font-size: 12px',
                            v-model='consultaDiagnosticoSocioambiental'
                        )
                        el-button(
                            :disabled='!departamentoSelecionado || !distritoSelecionado || !consultaDiagnosticoSocioambiental',
                            type='primary',
                            @click='processamentoParaguai(consultaDiagnosticoSocioambiental)',
                            size='mini',
                            icon='el-icon-plus'
                        )
            template(v-else)
                .ds-multiplos-card-campo-consulta
                    .ds-multiplos-card-campo-consulta__input
                        el-input(
                            :clearable='true',
                            prefix-icon='el-icon-search',
                            type='text',
                            @keyup.enter.native='adicionarProcessamento(consultaDiagnosticoSocioambiental)',
                            @keydown.tab.native='adicionarProcessamento(consultaDiagnosticoSocioambiental)',
                            :placeholder='$t("mensagens.diagnosticoSocioambiental.pesquisaPlaceholder")',
                            style='width: 100%; font-size: 12px',
                            v-model='consultaDiagnosticoSocioambiental'
                        )
                        el-button(
                            type='primary',
                            @click='adicionarProcessamento(consultaDiagnosticoSocioambiental)',
                            size='mini',
                            icon='el-icon-plus'
                        )

                .ds-multiplos-card-campo-consulta__mensagem-validacao(
                    v-if='consultaInvalida',
                    :class='[consultaInvalida ? "error" : ""]'
                ) {{ $t('mensagens.diagnosticoSocioambiental.pesquisaInvalida') }}

        .ds-multiplos-card-resultado--scroll(@scroll='handleScroll')
            .ds-multiplos-card-resultado_acoes
                .div.button-container
                    el-upload(
                        :show-file-list='false',
                        :file-list='listaArquivosUpload',
                        action='alert',
                        :auto-upload='false',
                        :on-change='onLoadFile',
                        :on-remove='onRemoveFile',
                        :on-exceed='onLimitExceed',
                        :limit='1',
                        ref='refUploadDsMultiplos'
                    )
                        el-tooltip.icone(
                            :content='$t("mensagens.diagnosticoSocioambiental.pesquisaPorArquivo")',
                            placement='bottom-start'
                        )
                            el-button(
                                type='primary',
                                round,
                                size='mini',
                                icon='el-icon-upload'
                            ) {{ $t('mensagens.diagnosticoSocioambiental.inserirArquivo') }}

                    el-button.button-lote(
                        v-if='this.usuarioLogado.ambienteLogado !== this.ambientes.PARAGUAY',
                        type='primary',
                        round,
                        size='mini',
                        icon='el-icon-files',
                        @click='abrirModalDiagnosticoSociambientalEmLote'
                    ) {{ $t('mensagens.diagnosticoSocioambiental.diagnosticoEmLote') }}

                    el-button.remover-todos(
                        v-if='Object.values(resultadosDiagnosticosSocioambientais)?.length > 1',
                        type='danger',
                        round,
                        @click='resetar()',
                        icon='el-icon-delete',
                        size='mini'
                    ) {{ $t('mensagens.diagnosticoSocioambiental.removerTodos') }}
            div(
                v-if='Object.values(resultadosDiagnosticosSocioambientais)?.length > 0'
            )
                h3.ds-multiplos-card-lista-resultado_titulo {{ $t('mensagens.diagnosticoSocioambiental.consultasProcessadas') }}

                el-collapse.ds-multiplos-card-resultado__collapse(
                    v-model='indexCollapseAgrupado',
                    @change='abrirFecharCollapsesPrimeiroNivel'
                )
                    el-collapse-item.ds-multiplos-card-resultado__item(
                        :name='resultado.idRequest',
                        v-for='(resultado, index) in Object.values(resultadosDiagnosticosSocioambientais)',
                        @click='iniciarPopoverInterno(resultado.idRequest)',
                        :key='resultado.idRequest',
                        v-loading='resultado.loading'
                    )
                        template(slot='title')
                            .ds-multiplos-card-resultado__deletar
                                el-button(
                                    type='danger',
                                    round,
                                    @click.stop='removerConsulta(resultado.idRequest)',
                                    icon='el-icon-delete',
                                    size='mini'
                                )
                            span.ds-multiplos-card-resultado__valor-consultado {{ resultado?.valorConsulta }}
                        p(v-if='resultado.erro') {{ $t('mensagens.diagnosticoSocioambiental.erro.ValorNaoEncontrado') }}

                        div(v-if='!resultado.erro')
                            .ds-multiplos-card-resultado(
                                :style='{ "flex-direction": isCollapsed ? "column" : "row" }'
                            )
                                .ds-multiplos-card-resultado__titulo
                                    i.el-icon-finished
                                    span {{ $t('mensagens.diagnosticoSocioambiental.resultadoDaAnalise') }}
                                .ds-multiplos-card-resultado__acoes
                                    div(v-if='resultado.geoJson')
                                        el-tooltip(
                                            :content='$t("mensagens.diagnosticoSocioambiental.zoomGeometria")',
                                            placement='top'
                                        )
                                            el-button.zoom-geometria-btn(
                                                @click='aplicarZoomGeometria(resultado)',
                                                size='mini',
                                                type='primary',
                                                icon='mdi mdi-crosshairs-gps'
                                            )
                                    div(
                                        v-if='resultado?.podeRealizarAnaliseProximidade'
                                    )
                                        el-tooltip(
                                            :content='$t("mensagens.diagnosticoSocioambiental.analisarProximidades")',
                                            placement='top'
                                        )
                                            el-button(
                                                @click='processarAnaliseProximidade(resultado.idRequest)',
                                                size='mini',
                                                type='primary',
                                                icon='el-icon-connection'
                                            )
                                    div
                                        el-tooltip(
                                            :content='$t("mensagens.diagnosticoSocioambiental.marcarParaExportacao")',
                                            placement='top'
                                        )
                                            el-popover(
                                                v-if='resultado?.podeRealizarAnaliseProximidade && resultado?.diagnosticoProximidade',
                                                placement='top',
                                                width='210',
                                                trigger='click',
                                                v-model='visiblePopoverMarcarParaPDF[resultado.idRequest]'
                                            )
                                                .ds-multiplos-card-resultado-acoes__exportar
                                                    div
                                                        el-button(
                                                            size='mini',
                                                            icon='el-icon-download',
                                                            @click='marcarExportacaoDiagnosticPdf(resultado)'
                                                        ) {{ $t('mensagens.diagnosticoSocioambiental.principalDiagnostico') }}
                                                    div
                                                        el-button(
                                                            size='mini',
                                                            icon='el-icon-download',
                                                            @click='marcarExportacaoDiagnosticPdfProximidade(resultado)'
                                                        ) {{ $t('mensagens.diagnosticoSocioambiental.principalProximidadesDiagnostico') }}

                                                el-button(
                                                    @click.middle='iniciarPopoverMarcarParaPDF(resultado.idRequest)',
                                                    slot='reference',
                                                    size='mini',
                                                    type='primary',
                                                    icon='el-icon-document-add'
                                                )
                                            div(v-else)
                                                el-button(
                                                    @click='marcarExportacaoDiagnosticPdf(resultado)',
                                                    size='mini',
                                                    type='primary',
                                                    icon='el-icon-document-add'
                                                )

                                    div
                                        el-tooltip(
                                            :content='$t("mensagens.diagnosticoSocioambiental.exportarDiagnostico")',
                                            placement='right'
                                        )
                                            el-popover(
                                                v-if='resultado?.podeRealizarAnaliseProximidade && resultado?.diagnosticoProximidade',
                                                placement='top',
                                                width='210',
                                                trigger='click',
                                                v-model='visible[resultado.idRequest]'
                                            )
                                                .ds-multiplos-card-resultado-acoes__exportar
                                                    div
                                                        el-button(
                                                            size='mini',
                                                            icon='el-icon-download',
                                                            @click='exportarPdf(resultado)'
                                                        ) {{ $t('mensagens.diagnosticoSocioambiental.principalDiagnostico') }}
                                                    div
                                                        el-button(
                                                            size='mini',
                                                            icon='el-icon-download',
                                                            @click='exportarPdfComAnaliseProximidade(resultado)'
                                                        ) {{ $t('mensagens.diagnosticoSocioambiental.principalProximidadesDiagnostico') }}
                                                el-button(
                                                    @click.middle='ativarPopoverInterno(resultado.idRequest)',
                                                    slot='reference',
                                                    size='mini',
                                                    type='primary',
                                                    :disabled='resultado.loadingDownloadPdfComAnaliseProximidade || resultado.loadingDownloadPdf',
                                                    :icon='resultado.loadingDownloadPdfComAnaliseProximidade || resultado.loadingDownloadPdf ? "el-icon-loading" : "el-icon-download"'
                                                )
                                            div(v-else)
                                                el-button(
                                                    @click='exportarPdf(resultado)',
                                                    size='mini',
                                                    type='primary',
                                                    :icon='resultado.loadingDownloadPdf ? "el-icon-loading" : "el-icon-download"'
                                                )

                            .ds-multiplos-card-resultado-informacoes-gerais(
                                v-if='resultado.informacoesGerais'
                            )
                                el-divider
                                .ds-multiplos-card-resultado-informacoes-gerais__titulo {{ $t('mensagens.diagnosticoSocioambiental.informacoesGerais') }}
                                .ds-multiplos-card-resultado-informacoes-gerais__linha(
                                    v-if='resultado.informacoesGerais.area_ha || resultado.informacoesGerais.faixaFronteiraFormatado',
                                    :style='{ "grid-template-columns": isCollapsed ? "repeat(2, 1fr)" : "repeat(3, 1fr)" }'
                                )
                                    .ds-multiplos-card-resultado-informacoes-gerais__item(
                                        v-if='resultado.informacoesGerais.area_ha'
                                    )
                                        template(
                                            v-if='usuarioLogado.ambienteLogado === ambientes.PARAGUAY'
                                        )
                                            label {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.distritoDepartamento') }}
                                            span {{ resultado.informacoesGerais.estadoMunicipio }}
                                        template(v-else)
                                            label {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.municipioUf') }}
                                            span {{ converterMunicipioUf(resultado.informacoesGerais.estadoMunicipio) }}
                                    .ds-multiplos-card-resultado-informacoes-gerais__item(
                                        v-if='resultado.informacoesGerais.area_ha'
                                    )
                                        label {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaHa') }}
                                        span {{ resultado.informacoesGerais.area_ha }}
                                    .ds-multiplos-card-resultado-informacoes-gerais__item(
                                        v-if='resultado.informacoesGerais.biomaFormatado'
                                    )
                                        label {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.bioma') }}
                                        span {{ resultado.informacoesGerais.biomaFormatado }}
                                    .ds-multiplos-card-resultado-informacoes-gerais__item(
                                        v-if='resultado.informacoesGerais.faixaFronteiraFormatado'
                                    )
                                        label(
                                            v-if='usuarioLogado.ambienteLogado !== ambientes.PARAGUAY'
                                        ) {{ $t('mensagens.diagnosticoSocioambiental.faixaDeFronteira') }}
                                        span(
                                            v-if='usuarioLogado.ambienteLogado !== ambientes.PARAGUAY'
                                        ) {{ resultado.informacoesGerais.faixaFronteiraFormatado }}

                                    .ds-multiplos-card-resultado-informacoes-gerais__item(
                                        v-if='resultado.informacoesGerais.moduloFiscal'
                                    )
                                        label {{ $t('mensagens.diagnosticoSocioambiental.moduloFiscal') }}
                                        span {{ resultado.informacoesGerais.moduloFiscal }}
                                    .ds-multiplos-card-resultado-informacoes-gerais__item(
                                        v-if='resultado.informacoesGerais.situacao'
                                    )
                                        label {{ $t('mensagens.diagnosticoSocioambiental.situacao') }}
                                        span {{ resultado.informacoesGerais.situacao }}

                                    .ds-multiplos-card-resultado-informacoes-gerais__linha(
                                        v-if='resultado.informacoesGerais.condicao'
                                    )

                                .ds-multiplos-card-resultado-informacoes-gerais__item
                                    label {{ $t('mensagens.diagnosticoSocioambiental.condicao') }}
                                    span {{ resultado.informacoesGerais.condicao }}
                                el-divider

                            .ds-multiplos-card-resultado-informacoes-gerais(
                                v-if='resultado.produtividade'
                            )
                                .ds-multiplos-card-resultado-informacoes-gerais__titulo {{ $t('mensagens.diagnosticoSocioambiental.capacidadeProdutiva') }}
                                .ds-multiplos-card-resultado-informacoes-gerais__linha(
                                    :style='{ "grid-template-columns": isCollapsed ? "repeat(2, 1fr)" : "repeat(3, 1fr)" }'
                                )
                                    .ds-multiplos-card-resultado-informacoes-gerais__item
                                        el-tooltip(placement='top', :content='$t("mensagens.diagnosticoSocioambiental.tooltipAreaProdutiva")')
                                            label
                                                i.mdi.mdi-information-outline.font-size-mdi.mr-1
                                                | {{ $t('mensagens.diagnosticoSocioambiental.areaProdutiva') }}
                                        span {{ formatarArea(resultado.produtividade) }}
                                    .ds-multiplos-card-resultado-informacoes-gerais__item
                                        el-tooltip(placement='top', :content='tooltipProdutividade(resultado.produtividade)')
                                            label
                                                i.mdi.mdi-information-outline.font-size-mdi.mr-1
                                                | {{ $t('mensagens.diagnosticoSocioambiental.produtividade') }}
                                        span {{ formatarProdutividade(resultado.produtividade) }}
                                    .ds-multiplos-card-resultado-informacoes-gerais__item
                                        el-tooltip(placement='top', :content='tooltipCapacidadeProdutiva(resultado.produtividade)')
                                            label
                                                i.mdi.mdi-information-outline.font-size-mdi.mr-1
                                                | {{ $t('mensagens.diagnosticoSocioambiental.capacidadeProdutiva') }}
                                        span {{ formatarCapacidadeProdutiva(resultado.produtividade) }}
                                el-divider

                            AccordionMultiplosDiagnosticosSocioambientais(
                                v-if='refMapa && resultado.diagnosticos',
                                :ref='"refDiagnosticoSocioambiental" + resultado.idRequest',
                                :dadosConsulta='resultado',
                                :habilitar-opacidade='true',
                                :indexDiagnostico='{ index: resultado.idRequest }',
                                @index-aberto='exibirRestricoesNoMapa',
                                :mapaLeaflet='refMapa',
                                :habilitar-zoom-restricao='true'
                            )

                            div(v-if='resultado.diagnosticoProximidade')
                                .ds-multiplos-card-resultado-proximidade(
                                    :id='"resultado-proximidade-" + resultado.idRequest + "-100"'
                                )
                                    i.el-icon-connection
                                    span {{ resultado.diagnosticoProximidade.tituloProximidade }}
                                AccordionMultiplosDiagnosticosSocioambientais(
                                    :ref='"refDiagnosticoSocioambientalProximidades-" + resultado.idRequest + "-100"',
                                    :dadosConsulta='resultado.diagnosticoProximidade',
                                    :habilitar-opacidade='true',
                                    :indexDiagnostico='{ index: resultado.idRequest + "-100" }',
                                    @index-aberto='exibirRestricoesNoMapa',
                                    :mapaLeaflet='refMapa',
                                    :habilitar-zoom-restricao='true'
                                )
            div(v-else)
                el-empty(
                    :description='$t("mensagens.diagnosticoSocioambiental.nenhumEncontrado")'
                )

    .mapa
        mapa(
            ref='mapa',
            :showStatesLayers='true',
            :mapLayersConfigs='layersMaps',
            :mapConfig='mapConfig',
            :height='"100%"',
            :idMapa='"mapaDiagnosticoSocioambiental"',
            @diagnostico='realizarDiagnosticoSocioAmbientalPeloMapa',
            :atualizarMapa='true',
            :cluster='false',
            :menuMaior='true'
        )

    div(v-if='exibirModalCarParcelasIncra')
        ModalSelecionarDadosCpfCnpj(
            :show='exibirModalCarParcelasIncra',
            :cpfCnpj='cpfCnpjModalIncra',
            :dados='dadosModalCarParcelaIncra',
            tipo='DIAGNOSTICO',
            @voltar='exibirModalCarParcelasIncra = false',
            @retornarDadosSelecionados='adicionarProcessamentoAposModal'
        )

    ModalDiagnosticoSociambientalEmLote(
        v-if='mostrarModalDiagnosticoSociambientalEmLote',
        :show='mostrarModalDiagnosticoSociambientalEmLote',
        @voltar='fecharModalDiagnosticoSociambientalEmLote'
    )
    ModalSelecionarDadosFincaPadron(
        :show='mostrarModalModalSelecionarDadosFincaPadron',
        :dados='dataFincaPadron',
        @retornarDadosSelecionados='adicionarProcessamentoAposModalFincaPadron',
        @voltar='mostrarModalModalSelecionarDadosFincaPadron = false'
    )
</template>

<script>
import L from 'leaflet';
import { uuid } from 'vue-uuid';
import { mapGetters, mapActions } from 'vuex';

import Mapa from '@/components/MapaLeaflet.vue';
import AccordionMultiplosDiagnosticosSocioambientais from '@/components/diagnosticoSocioambiental/AccordionMultiplosDiagnosticosSocioambientais.vue';
import ModalSelecionarDadosCpfCnpj from '@/components/ModalSelecionarDadosCpfCnpj.vue';
import ModalSelecionarDadosFincaPadron from '@/components/ModalSelecionarDadosFincaPadron.vue';
import ModalDiagnosticoSociambientalEmLote from '@/components/diagnosticoSocioambiental/ModalDiagnosticoSociambientalEmLote.vue';

import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import SigefService from '@/services/SigefService';
import CarService from '@/services/car/CarService';
import TerritorioService from '@/services/TerritorioService';
import LocalidadeService from '@/services/LocalidadeService';

import { camadasDiagnostico } from '@/constants/DiagnosticoSocioAmbientalCamadas';

import { connect, subscribe, disconnect } from '@/utils/websocket';
import { retryOperation } from '@/utils/retry-operation';
import validators from '@/utils/validations/validators';
import formatters from '@/utils/formatters';
import CarUtils from '@/utils/CarUtils';
import centroidFromGeoJSON from '@/utils/centroidFromGeoJSON';
import geoJsonConverter from '@/utils/conversorGeojson';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';

import { TipoAcaoGeometriaDesenhada } from '@/constants/TipoAcaoGeometriaDesenhada';

import '@/utils/mapa/leaflet-polygon-fillPattern/leaflet-polygon.fillPattern.js';

import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';
const restricaoPattern =
    'https://lyra-bunge-publico.s3.amazonaws.com/restricao_pattern.gif';

export default {
    name: 'DiagnosticosSocioambientaisView',

    components: {
        Mapa,
        AccordionMultiplosDiagnosticosSocioambientais,
        ModalSelecionarDadosCpfCnpj,
        ModalDiagnosticoSociambientalEmLote,
        ModalSelecionarDadosFincaPadron
    },

    data() {
        return {
            case: {
                INCRA: 'INCRA',
                PARCELA_SIGEF: 'PARCELA_SIGEF',
                GEOMETRIA: 'GEOMETRIA',
                CPF_CNPJ: 'CPF_CNPJ',
                ARQUIVO: 'ARQUIVO',
                CODIGOCAR: 'CODIGOCAR',
                FINCA_PADRON: 'FINCA_PADRON',
                IDTERRITORIO: 'IDTERRITORIO'
            },
            layersMaps: [],
            departamentoSelecionado: null,
            distritoSelecionado: null,
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    bufferControl: false
                },
                inspecionar: true,
                diagnostico: true
            },
            refMapa: null,
            consultaDiagnosticoSocioambiental: null,
            departamento: {
                lista: [],
                loading: false
            },
            distrito: {
                lista: [],
                loading: false
            },
            listaArquivosUpload: [],
            consultaInvalida: false,
            resultadosDiagnosticosSocioambientais: [],
            resultadoImovelCar: {},
            indexCollapseAgrupado: '',
            camadasAtivas: [],
            exibirModalCarParcelasIncra: false,
            cpfCnpjModalIncra: null,
            dadosModalCarParcelaIncra: {
                carEstadoPaginado: [],
                existemDados: false,
                sigef: []
            },
            visible: [],
            visiblePopoverMarcarParaPDF: [],
            collapsePrincipalRestricoesAbertas: [],
            collapsePrincipalAbertos: [],
            collapseProximidadeRestricoesAbertas: [],
            nomeGeometriaDesenhada: 0,
            loadingProcessamento: false,
            mostrarModalDiagnosticoSociambientalEmLote: false,
            isCollapsed: false,
            ambientes: AmbientesEmpresas,
            mostrarModalModalSelecionarDadosFincaPadron: false,
            dataFincaPadron: [],
            idTerritorio: this.$route.params.idTerritorio
        };
    },

    computed: {
        ...mapGetters([
            'geometriaDesenhadaAcao',
            'acaoEscolhida',
            'usuarioLogado'
        ])
    },

    watch: {
        'usuarioLogado.ambienteLogado': {
            immediate: true,
            handler(ambiente) {
                if (ambiente === 'PY') {
                    this.listarLocalidadeNivelUm();
                }
            }
        },

        consultaDiagnosticoSocioambiental: function (consulta) {
            if (!consulta) return;
            this.adicionarMascaraNaConsulta(consulta);
        }
    },

    async mounted() {
        this.refMapa = this.$refs['mapa'];
        /**
         * Em outros arquivos está acontecend
         * o 'off' total, precisamos rever esse comportament
         *
         * Esse on adiciona as camadas em um arra
         * quando habilitadas no mapa e remove quando desabilitada
         * Ex: CAR/AREA_EMBARGADA/PODRES e et
         */
        this.$bus.$on('mapa:camadas-ativas-diagnostico', data => {
            this.camadasAtivas = [];
            data.map(layer => {
                this.camadasAtivas.push(layer.layerName);
            });
        });

        /**
         * Realizar o diagnostico quando vindo de outra página
         *
         */
        if (
            this.acaoEscolhida &&
            this.acaoEscolhida.acao ===
                TipoAcaoGeometriaDesenhada.DIAGNOSTICO_SOCIOAMBIENTAL
        ) {
            await this.realizarDiagnosticoSocioAmbientalPeloMapa(
                this.geometriaDesenhadaAcao
            );
        }

        /**
         * Realizar o diagnostico quando vindo de outra página trazendo idTerritorio
         *
         */
        if (this.idTerritorio) {
            this.buscarGeometriaTerritorio();
        }
    },

    beforeDestroy() {
        this.removerAcaoEscolhida();
        this.removerGeometriaDesenhadaAcao();
    },

    methods: {
        ...mapActions([
            'removerGeometriaDesenhadaAcao',
            'removerAcaoEscolhida',
            'setMarcarExportar_PDF'
        ]),
        /**
         * Resetar
         *
         */
        fecharModalDiagnosticoSociambientalEmLote() {
            this.mostrarModalDiagnosticoSociambientalEmLote = false;
        },
        formatarArea(produtividade) {
            if (!produtividade) return '---';
            const area = produtividade.area
                ? formatters.formatNumber(produtividade.area, 2)
                : '---';
            return `${area} ${produtividade.areaUnidadeMedida || 'ha'}`;
        },
        formatarProdutividade(produtividade) {
            if (!produtividade) return '---';
            const valor = produtividade.produtividade ? produtividade.produtividade : '---';
            const unidade = produtividade.produtividadeUnidadeMedida || '';
            const mediaRegional = produtividade.calculoSaca?.mediaRegional
                ? produtividade.calculoSaca.mediaRegional
                : '---';
            return `${valor} ${unidade} (${mediaRegional} sc/ha)`;
        },
        formatarCapacidadeProdutiva(produtividade) {
            if (!produtividade || !produtividade.capacidadeProdutiva) return '---';
            return `${produtividade.capacidadeProdutiva.toFixed(2)} t (${produtividade.calculoSaca?.produtividade || '---'} sc)`;
        },
        tooltipProdutividade(produtividade) {
            if (produtividade?.fonteDados?.nome) {
                return `${this.$t('mensagens.diagnosticoSocioambiental.fonte')}: ${produtividade.fonteDados.nome}`;
            }
            return this.$t('mensagens.diagnosticoSocioambiental.produtividade');
        },
        tooltipCapacidadeProdutiva(produtividade) {
            if (!produtividade) return '';
            const fator = produtividade.fatorProdutividade !== null && produtividade.fatorProdutividade !== undefined
                ? formatters.formatNumber(1 + produtividade.fatorProdutividade, 2)
                : '---';
            return `(${this.$t('mensagens.diagnosticoSocioambiental.areaProdutiva')} x ${this.$t('mensagens.diagnosticoSocioambiental.produtividade')}) x ${fator}`;
        },
        converterMunicipioUf(stringComplete) {
            if (stringComplete) {
                const uf = stringComplete.substring(0, 2);
                const municipio = stringComplete.substring(
                    4,
                    stringComplete.length
                );
                return `${municipio} - ${uf}`;
            }
            return this.$t(
                'mensagens.diagnosticoSocioambiental.municipioNaoEncontrado'
            );
        },
        resetar() {
            this.layersMaps = [];
            this.consultaDiagnosticoSocioambiental = null;
            this.departamentoSelecionado = null;
            this.distritoSelecionado = null;
            this.listaArquivosUpload = [];
            this.consultaInvalida = false;
            this.resultadosDiagnosticosSocioambientais = [];
            this.resultadoImovelCar = {};
            this.indexCollapseAgrupado = '';
            this.visible = [];
            this.visiblePopoverMarcarParaPDF = [];
            this.collapsePrincipalRestricoesAbertas = [];
            this.collapsePrincipalAbertos = [];
            this.collapseProximidadeRestricoesAbertas = [];

            this.$notify.success({
                message: this.$t(
                    'mensagens.diagnosticoSocioambiental.processamentoRemovido'
                )
            });

            // cancelar as possíveis request que foram realizdas e não finalizaram
            window.stop();
        },

        /**
         * Verifica o tipo do processamento e chama a função para processar
         *
         * @param {*} valorConsulta Valor do input adicionado
         * @param {*} geoJson Geometria do kml
         * @param {*} conteudo Opcional - importante quando o nome não pode ser o 'valorConsulta'
         */
        async adicionarProcessamento(valorConsulta, geoJson, conteudo = null) {
            if (this.loadingProcessamento) {
                return;
            }
            /**
             * Limpando variáveis usadas ao abrir modal de INCRA/CAR/Parcel
             */
            this.cpfCnpjModalIncra = null;
            this.dadosModalCarParcelaIncra = {
                carEstadoPaginado: [],
                existemDados: false,
                listaSigef: [],
                sigef: []
            };
            this.listaArquivosUpload = [];

            const caseSelecionado = this.buscarTipoDaConsulta(
                valorConsulta,
                geoJson
            );

            // Se o campo estiver inválido
            this.consultaInvalida = !caseSelecionado || false;
            if (this.consultaInvalida) return false;

            this.loadingProcessamento = true;
            switch (caseSelecionado) {
                case this.case.PARCELA_SIGEF:
                    const consultaSigefPorCodigoValida =
                        this.validarConsulta(valorConsulta);
                    if (consultaSigefPorCodigoValida) {
                        const { data: geometriaParcelaSigefPorCodigo } =
                            await SigefService.buscarGeometriaParcela(
                                valorConsulta
                            );
                        this.processar({
                            tipo: this.case.ARQUIVO,
                            valorConsulta,
                            geoJson: JSON.parse(
                                JSON.stringify(geometriaParcelaSigefPorCodigo)
                            )
                        });
                    }
                    break;
                case this.case.INCRA:
                    const { data: geometriaParcelaSigefPorCodigoIncra } =
                        await SigefService.consultarINCRA(valorConsulta);
                    this.dadosModalCarParcelaIncra = {
                        listaSigef: geometriaParcelaSigefPorCodigoIncra
                    };
                    this.exibirModalCarParcelasIncra =
                        !!geometriaParcelaSigefPorCodigoIncra.length;
                    this.cpfCnpjModalIncra = this.case.INCRA;
                    break;
                case this.case.CPF_CNPJ:
                    /**
                     * Verificação do SIGE
                     */
                    this.cpfCnpjModalIncra = valorConsulta;
                    const cpfCnpj = valorConsulta.replace(/[^A-Z0-9]/g, '');
                    const { data: geometriaParcelaSigefPorDocumento } =
                        await SigefService.consultarCpfCnpj(cpfCnpj);
                    if (geometriaParcelaSigefPorDocumento.length) {
                        this.dadosModalCarParcelaIncra = {
                            listaSigef: geometriaParcelaSigefPorDocumento
                        };
                        this.exibirModalCarParcelasIncra =
                            !!geometriaParcelaSigefPorDocumento.length;
                    } else {
                        const { data: geometriaCarDocumento } =
                            await CarService.buscarCarPorCpfCnpjVinculado(
                                cpfCnpj
                            );
                        if (geometriaCarDocumento.existemDados) {
                            this.dadosModalCarParcelaIncra = {
                                ...geometriaCarDocumento,
                                listaSigef: []
                            };
                            this.exibirModalCarParcelasIncra =
                                geometriaCarDocumento.existemDados;
                        } else {
                            const valorConsultadoAdicionadoValido =
                                this.validarConsulta(valorConsulta);
                            if (valorConsultadoAdicionadoValido) {
                                this.processar({
                                    tipo: caseSelecionado,
                                    valorConsulta,
                                    geoJson
                                });
                            }
                        }
                    }
                    break;
                case this.case.ARQUIVO:
                case this.case.CODIGOCAR:
                case this.case.GEOMETRIA:
                    const valorConsultadoAdicionadoValido =
                        this.validarConsulta(valorConsulta);
                    if (valorConsultadoAdicionadoValido) {
                        this.processar({
                            tipo: caseSelecionado,
                            valorConsulta,
                            geoJson,
                            conteudo
                        });
                    }
                    break;
                case this.case.IDTERRITORIO:
                    if (this.validarConsulta(valorConsulta)) {
                        this.processar({
                            tipo: caseSelecionado,
                            valorConsulta,
                            geoJson,
                            conteudo
                        });
                    }
                    break;
                default:
                    this.$notify.error({
                        message:
                            'Tipo de Diagnóstico Socioambiental não implementado.'
                    });
                    break;
            }

            this.loadingProcessamento = false;
        },

        /**
         * Depois que os dados foram selecionados na modal
         * de Car/Parcela/Incra, realizamos validações e consultas
         * dessa seleção e processamos.
         *
         * @param {*} dadosModalCarParcelaIncra Dados selecionados na modal
         */
        async adicionarProcessamentoAposModal(dadosModalCarParcelaIncra) {
            let retorno = null;
            let geoJson = null;
            let caseSelecionado = null;
            let valorConsultadoAdicionadoValido = null;

            if (dadosModalCarParcelaIncra.codigo) {
                valorConsultadoAdicionadoValido = this.validarConsulta(
                    dadosModalCarParcelaIncra.codigo
                );
                if (valorConsultadoAdicionadoValido) {
                    retorno = dadosModalCarParcelaIncra.codigo;
                    caseSelecionado = this.buscarTipoDaConsulta(retorno, null);
                }
            } else if (dadosModalCarParcelaIncra.codigoParcela) {
                valorConsultadoAdicionadoValido = this.validarConsulta(
                    dadosModalCarParcelaIncra.codigoParcela
                );
                if (valorConsultadoAdicionadoValido) {
                    retorno = dadosModalCarParcelaIncra.codigoParcela;
                    const { data } = await SigefService.buscarGeometriaParcela(
                        retorno
                    );
                    geoJson = JSON.parse(JSON.stringify(data));
                    caseSelecionado = this.case.ARQUIVO;
                }
            } else {
                valorConsultadoAdicionadoValido = this.validarConsulta(
                    dadosModalCarParcelaIncra
                );
                if (valorConsultadoAdicionadoValido) {
                    retorno = dadosModalCarParcelaIncra;
                    caseSelecionado = this.buscarTipoDaConsulta(retorno, null);
                }
            }

            if (valorConsultadoAdicionadoValido) {
                this.processar({
                    tipo: caseSelecionado,
                    valorConsulta: retorno,
                    geoJson
                });
                this.exibirModalCarParcelasIncra = false;
            }
        },

        /**
         * Validar se a consulta pode ser processada
         *
         * @param {*} valorConsulta Valor do campo de consulta
         */
        validarConsulta(valorConsulta) {
            // Se o campo estiver inválido
            if (!valorConsulta) return false;

            // Valor já foi adicionado
            const foiAdicionado = Object.values(
                this.resultadosDiagnosticosSocioambientais
            ).find(c => c.conteudo === valorConsulta);
            if (foiAdicionado) {
                this.$notify.info({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.consultaAdicionada'
                    )
                });
                this.consultaDiagnosticoSocioambiental = null;
                return false;
            }

            return true;
        },

        /**
         * Adiciona máscara na consulta
         * CAR/CPF/CNPJ/PARCELA
         *
         * @param {*} consulta Valor do campo de consulta
         */
        adicionarMascaraNaConsulta(consulta) {
            consulta = consulta.replace(/[^\w\s]/gi, '');

            switch (true) {
                // CODIGO_INCRA
                case consulta.length === 13:
                    this.consultaDiagnosticoSocioambiental = consulta;
                    break;
                // CPF_CNPJ
                case consulta.length <= 14:
                    this.consultaDiagnosticoSocioambiental =
                        formatters.numeralStringFormatTocpfCnpj(consulta);
                    break;
                // PARCELA_SIGEF
                case consulta.length <= 32:
                    this.consultaDiagnosticoSocioambiental =
                        formatters.formatCodigoParcela(consulta);
                    break;
                // CODIGOCAR
                default:
                    const consultaUpperCase =
                        CarUtils.addMascaraCar(consulta).toUpperCase();
                    this.consultaDiagnosticoSocioambiental = consultaUpperCase;
                    break;
            }
        },

        /**
         * Identifica qual é o tipo da consulta
         *
         * CAR/CPF/CNPJ/PARCELA/INCRA
         *
         * @param {*} valorConsulta Valor do campo de consulta
         * @param {*} geoJson Geometria do arquivo, caso o usuário realizado o upload
         */
        buscarTipoDaConsulta(valorConsulta, geoJson) {
            if (geoJson) return this.case.ARQUIVO;
            if (this.idTerritorio) return this.case.IDTERRITORIO;

            const tipoConsulta = {
                13: this.case.INCRA,
                14: null,
                18: null,
                36: this.case.PARCELA_SIGEF,
                43: this.case.CODIGOCAR
            };

            if (valorConsulta.length === 14 || valorConsulta.length === 18) {
                if (validators.validarDocumento(valorConsulta)) {
                    tipoConsulta[14] = this.case.CPF_CNPJ;
                    tipoConsulta[18] = this.case.CPF_CNPJ;
                }
            }

            return tipoConsulta[valorConsulta.length];
        },

        onLimitExceed() {
            this.$notify.warning({
                message: this.$t(
                    'mensagens.diagnosticoSocioambiental.erro.consultaPorVez'
                )
            });
        },
        onRemoveFile() {
            this.listaArquivosUpload = [];
            if (this.$refs['refUploadDsMultiplos']) {
                this.$refs['refUploadDsMultiplos'].clearFiles();
            }
        },

        /**
         * Realiza o upload do arquivo
         * e adiciona para processamento
         *
         * @param {*} file Arquivo que foi feito o upload
         */
        onLoadFile(file) {
            let reader = new FileReader();

            let extension = file.name.split('.').pop().toLowerCase();

            reader.onload = async e => {
                await geoJsonConverter
                    .parse(extension, e.target.result, file.raw)
                    .then(geoJson => {
                        if (
                            this.usuarioLogado.ambienteLogado ===
                            this.ambientes.PARAGUAY
                        ) {
                            this.processamentoParaguai(
                                file.name,
                                geoJson.features.map(f => f.geometry)[0]
                            );
                        } else {
                            this.adicionarProcessamento(
                                file.name,
                                geoJson.features.map(f => f.geometry)[0]
                            );
                        }
                    })
                    .catch(rejectReason => {
                        this.$refs['refUploadDsMultiplos'].clearFiles();
                        this.$notify.error({ message: rejectReason });
                    });
            };

            reader.readAsText(file.raw);
        },

        /**
         * Remove o processamento de um Diagnóstico Socioambiental pelo index que foi clicado
         *
         * @param {*} indexDiagnostico Index do diangnóstico que foi clicado
         */
        removerConsulta(indexDiagnostico) {
            this.limparGeometriasMapa(indexDiagnostico);

            const indexDiagnosticoProximidade = indexDiagnostico + '-100';

            delete this.resultadosDiagnosticosSocioambientais[indexDiagnostico];

            if (
                this.indexCollapseAgrupado !== '' &&
                this.indexCollapseAgrupado.length > 0
            ) {
                this.indexCollapseAgrupado = this.indexCollapseAgrupado.filter(
                    c => c !== indexDiagnostico
                );
            }

            this.collapsePrincipalAbertos =
                this.collapsePrincipalAbertos.filter(
                    c => c !== indexDiagnostico
                );
            this.collapsePrincipalRestricoesAbertas =
                this.collapsePrincipalRestricoesAbertas.filter(
                    c => c !== indexDiagnostico
                );
            this.collapseProximidadeRestricoesAbertas =
                this.collapseProximidadeRestricoesAbertas.filter(
                    c => c !== indexDiagnosticoProximidade
                );

            this.$notify.success({
                message: this.$t(
                    'mensagens.diagnosticoSocioambiental.removidoSucesso'
                )
            });
        },

        /**
         * Realiza Diagnóstico Socioambiental na api
         * conforme os dados adicionados para processamento
         *
         * @param {valorConsulta, geoJson, tipo} consulta O valor da consulta, tipo da consulta e caso seja um geojson
         */
        processar(consulta) {
            if (this.consultaInvalida) {
                return;
            }

            consulta.loading = true;

            // limpar campo de busca
            this.consultaDiagnosticoSocioambiental = null;
            this.departamentoSelecionado = null;
            this.distritoSelecionado = null;

            // remove arquivo
            // TODO: melhorar isso
            this.onRemoveFile();

            const idRequest = uuid.v1();
            const evelope = {
                idRequest,
                valorConsulta: consulta.valorConsulta,
                conteudo: consulta.conteudo
                    ? consulta.conteudo
                    : consulta.valorConsulta,
                loading: consulta.loading,
                geoJson: consulta.geoJson,
                tipo: consulta.tipo,
                erro: false,
                informacoesGerais: null,
                podeRealizarAnaliseProximidade: false,
                loadingDownloadPdf: false,
                loadingDownloadPdfComAnaliseProximidade: false,
                idDiagnosticoSocioambiental: 0,
                diagnosticoProximidade: null
            };
            if (this.resultadosDiagnosticosSocioambientais.length === 0) {
                this.resultadosDiagnosticosSocioambientais = {};
            }
            this.$set(
                this.resultadosDiagnosticosSocioambientais,
                idRequest,
                evelope
            );

            const isArquivo = consulta.tipo === 'ARQUIVO';
            const tipo = isArquivo ? this.case.GEOMETRIA : consulta.tipo;
            let documento = isArquivo ? 'geometria' : consulta.valorConsulta;
            const arquivo = isArquivo ? JSON.stringify(consulta.geoJson) : null;

            if (tipo === this.case.CPF_CNPJ) {
                documento = documento.replace(/\D/g, '');
            }

            DiagnosticoSocioambientalService.consultarMultiplos(
                tipo,
                documento,
                arquivo,
                idRequest
            )
                .then(({ data }) => {
                    let resultadoDiagnostico;
                    let geometria = null;
                    if (data.dataCAR.length === 1) {
                        geometria = data.dataCAR[0].imovel.geometria;
                        resultadoDiagnostico = this.ordenarFiltrarCustomizar(
                            data.dataCAR[0].diagnosticos,
                            null,
                            data.documento
                        );
                        this.resultadoImovelCar = data.dataCAR[0].imovel;
                    } else {
                        resultadoDiagnostico = this.ordenarFiltrarCustomizar(
                            data.dataCAR,
                            data.tipoBusca === this.case.CPF_CNPJ
                                ? data.documento
                                : null,
                            null
                        );
                    }
                    const itemIndex = data.idRequest;

                    if (this.usuarioLogado.isRevenda) {
                        let diagnosticosFiltro = [];
                        resultadoDiagnostico.forEach(diagnostico => {
                            if (
                                diagnostico.camada.codigo !==
                                    'CONTROLE_DESMATAMENTO_AMAZONIA' &&
                                diagnostico.camada.codigo !==
                                    'CONTROLE_DESMATAMENTO_AMAZONIA_PONTOS' &&
                                diagnostico.camada.codigo !==
                                    'CONTROLE_DESMATAMENTO_AMAZONIA_CONSOLIDADA'
                            ) {
                                diagnosticosFiltro.push(diagnostico);
                            }
                        });

                    this.resultadosDiagnosticosSocioambientais[
                            itemIndex
                        ].diagnosticos = diagnosticosFiltro;
                    } else {
                        this.resultadosDiagnosticosSocioambientais[
                            itemIndex
                        ].diagnosticos = resultadoDiagnostico;
                    }

                    this.resultadosDiagnosticosSocioambientais[
                        itemIndex
                    ].loading = false;
                    if (data.informacoes_gerais) {
                        this.resultadosDiagnosticosSocioambientais[
                            itemIndex
                        ].informacoesGerais = data.informacoes_gerais;
                    }

                    if (data.produtividade) {
                        this.resultadosDiagnosticosSocioambientais[
                            itemIndex
                        ].produtividade = data.produtividade;
                    }

                    if (geometria) {
                        this.resultadosDiagnosticosSocioambientais[
                            itemIndex
                        ].geoJson = geometria;
                    }

                    const contemGeoJson =
                        this.resultadosDiagnosticosSocioambientais[itemIndex]
                            .geoJson;

                    if (contemGeoJson) {
                        this.resultadosDiagnosticosSocioambientais[
                            itemIndex
                        ].podeRealizarAnaliseProximidade = true;
                    }

                    if (data.idDiagnosticoSocioambiental) {
                        this.resultadosDiagnosticosSocioambientais[
                            itemIndex
                        ].idDiagnosticoSocioambiental =
                            data.idDiagnosticoSocioambiental;
                    }
                })
                .catch(error => {
                    if (error && error.config && error.config.url) {
                        const url = error.config.url;

                        const regex =
                            /([a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12})/;

                        const matches = url.match(regex);

                        if (matches && matches.length > 1) {
                            const idRequest = matches[1];
                            const item = Object.values(
                                this.resultadosDiagnosticosSocioambientais
                            ).find(r => r.idRequest === idRequest);
                            item.loading = false;
                            item.erro = true;
                        }
                    }
                });

            this.$notify.success({
                message: this.$t(
                    'mensagens.diagnosticoSocioambiental.consultaProcessamento'
                )
            });
        },

        /**
         * Realizar uma ordenação nas camadas
         * filtros e tratativas de opacidade.
         *
         * @param {*} diagnosticos
         * @param {*} cpfCnpj
         * @param {*} codigoCar
         */
        ordenarFiltrarCustomizar(diagnosticos, cpfCnpj, codigoCar) {
            // TODO: Levar para o backend alguns pontos se possível.
            let updatedDiagnosticos = diagnosticos.map(diagnostico => ({
                ...diagnostico,
                camada: {
                    ...diagnostico.camada
                },
                opacidade: 100,
                cpfCnpj,
                codigoCar
            }));
            updatedDiagnosticos = updatedDiagnosticos.filter(
                ({ camada }) =>
                    camada.codigo !== 'APP_DEGRADADA' &&
                    camadasDiagnostico.includes(camada.codigo)
            );

            updatedDiagnosticos.forEach(diagnostico => {
                if (diagnostico.camada.nome === 'Áreas embargadas') {
                    diagnostico.camada.nome += ' (IBAMA)';
                }
                if (diagnostico.camada.codigo === 'APP') {
                    diagnostico.component = 'app-camada';
                } else {
                    diagnostico.component = diagnostico.camada.codigo
                        .toLowerCase()
                        .replaceAll('_', '-');
                }
            });

            updatedDiagnosticos = updatedDiagnosticos.sort((a, b) => {
                const specialOrder = ['Red Flag', 'Yellow Flag'];

                const indexA = specialOrder.indexOf(a.camada.nome);
                const indexB = specialOrder.indexOf(b.camada.nome);

                if (indexA !== -1 || indexB !== -1) {
                    if (indexA !== -1 && indexB !== -1) {
                        return indexA - indexB;
                    }
                    return indexA !== -1 ? 1 : -1;
                }

                return a.camada.nome.localeCompare(b.camada.nome);
            });

            return updatedDiagnosticos;
        },

        /**
         * Exibe as restrições no mapa ao abrir o collapse das restrições
         *
         * @param {*} _
         * @param {*} indexCollapse index do collapse clicado
         * @param {*} indexRestricao index do collapse da restrição clicada
         */
        exibirRestricoesNoMapa(_, indexDiagnostico, indexsRestricao) {
            if (typeof indexsRestricao === 'string' && indexsRestricao === '') {
                return;
            }

            const indexDiagnosticoAtual = indexDiagnostico;
            const diagnosticoProximidade = indexDiagnostico.includes('-100');

            indexDiagnostico = diagnosticoProximidade
                ? indexDiagnostico.replace('-100', '')
                : indexDiagnostico;

            if (diagnosticoProximidade) {
                this.abrirFecharCollapsesRestricoesProximidade(
                    indexDiagnosticoAtual,
                    indexsRestricao
                );
            } else {
                this.abrirFecharCollapsesRestricoes(
                    indexDiagnostico,
                    indexsRestricao
                );
            }

            indexsRestricao = indexsRestricao.filter(i => i !== '');

            indexsRestricao.forEach(indexRestricao => {
                const diagnosticoAberto =
                    this.resultadosDiagnosticosSocioambientais[
                        indexDiagnostico
                    ];

                let diagnostico = diagnosticoProximidade
                    ? diagnosticoAberto.diagnosticoProximidade.diagnosticos[
                          indexRestricao
                      ]
                    : diagnosticoAberto.diagnosticos[indexRestricao];

                const opacidade =
                    diagnostico.camada.opacidade >= 0.0
                        ? diagnostico.camada.opacidade / 200
                        : 0.5;

                const areas = diagnostico.resultados.filter(
                    resultado =>
                        resultado.geometria ||
                        resultado.geometry ||
                        (resultado.properties.latitude &&
                            resultado.properties.longitude)
                );

                areas.forEach((area, index) => {
                    let geometria = area.geometria || area.geometry;
                    let exibeCentroid = true;

                    if (geometria) {
                        let style = {
                            color: '#c20a0a',
                            weight: 1,
                            fill: 'url(' + restricaoPattern + ')',
                            opacity: opacidade,
                            fillOpacity: opacidade
                        };
                        if (geometria.type === 'Point') {
                            style = {
                                color: 'red',
                                weight: 2,
                                opacity: 1,
                                fillOpacity: 0.8
                            };
                        }
                        const name = `AreaDiagnostico_red_${indexDiagnosticoAtual}_${indexRestricao}_${index}`;

                        if (
                            !this.layersMaps.find(layer => layer.name === name)
                        ) {
                            this.layersMaps.push({
                                name,
                                indexDiagnostico: indexDiagnosticoAtual,
                                group: `grupo-restricoes-${indexDiagnosticoAtual}-${indexRestricao}`,
                                style,
                                geoJson: geometria
                            });
                        }

                        let icon = null;

                        if (geometria.type !== 'Point' && exibeCentroid) {
                            icon = L.icon({
                                iconUrl:
                                    'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                                iconSize: [18, 18]
                            });
                            const nameCentroid = `CentroidDiagnostico_${index}_${indexDiagnosticoAtual}`;
                            if (
                                !this.layersMaps.find(
                                    layer => layer.name === nameCentroid
                                )
                            ) {
                                this.layersMaps.push({
                                    name: nameCentroid,
                                    group: `grupo-centroid-${indexDiagnosticoAtual}-${indexRestricao}`,
                                    indexDiagnostico: indexDiagnostico,
                                    icon,
                                    geoJson: centroidFromGeoJSON.get(geometria)
                                });
                            }
                        }
                    } else {
                        const { properties } = area;
                        if (
                            properties &&
                            properties.latitude &&
                            properties.longitude
                        ) {
                            const name = `AreaDiagnostico_red_${indexDiagnosticoAtual}_${indexRestricao}_${index}`;
                            if (
                                !this.layersMaps.find(
                                    layer => layer.name === name
                                )
                            ) {
                                this.layersMaps.push({
                                    name,
                                    indexDiagnostico: indexDiagnosticoAtual,
                                    group: `grupo-restricoes-${indexDiagnosticoAtual}-${indexRestricao}`,
                                    style: {
                                        color: '#c20a0a',
                                        weight: 10,
                                        fill: 'url(' + restricaoPattern + ')',
                                        opacity: 0.5,
                                        fillOpacity: opacidade
                                    },
                                    geoJson: {
                                        type: 'Point',
                                        coordinates: [
                                            properties.longitude,
                                            properties.latitude
                                        ]
                                    }
                                });
                            }
                        }
                    }
                });
            });
        },

        /**
         * Processamento das proximidades do Diagnóstico Socioambiental
         *
         * @param {*} index Index do Diagnóstico Socioambiental clicado
         */
        async processarAnaliseProximidade(index) {
            let resultado = this.resultadosDiagnosticosSocioambientais[index];
            if (resultado.diagnosticoProximidade) {
                document
                    .getElementById('resultado-proximidade-' + index + '-100')
                    .scrollIntoView({ behavior: 'smooth', block: 'start' });
                return;
            }

            try {
                const { data } =
                    await DiagnosticoSocioambientalService.analisarBuffer(
                        [JSON.stringify(resultado.geoJson)],
                        resultado.idDiagnosticoSocioambiental
                    );
                const diagnosticos = [];
                data.dados.forEach(d =>
                    d.forEach(t => {
                        diagnosticos.push(t);
                    })
                );

                const geometrias = [];
                data.geometrias.forEach(g => {
                    geometrias.push(JSON.parse(g));
                });

                resultado.diagnosticoProximidade = {
                    diagnosticos: this.ordenarFiltrarCustomizar(diagnosticos),
                    geometria: geometrias,
                    tituloProximidade: data.tituloProximidade
                };

                const indexProximidade = index + '-100';
                this.layersMaps.push({
                    style: getEstiloGeometria('area'),
                    indexDiagnostico: indexProximidade,
                    name: `AnaliseProximidade-${indexProximidade}`,
                    geoJson: geometrias
                });

                setTimeout(() => {
                    document
                        .getElementById(
                            'resultado-proximidade-' + indexProximidade
                        )
                        .scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 1000);
            } catch (e) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.erro.buscarDadosBuffer'
                    )
                });
            }
        },

        /**
         * Realiza o download do PDF
         * a partir dos dados do
         * diagnóstico socioambiental
         * que foi clicado
         *
         * @param {*} resultado
         */
        async exportarPdf(resultado) {
            this.visible = false;
            try {
                await connect();

                resultado.loadingDownloadPdf = true;

                this.adicionarSubscribeDownloadPdf(resultado);

                let documento;
                let arquivoNome = null;

                switch (resultado.tipo) {
                    case this.case.CODIGOCAR:
                        documento = resultado.valorConsulta.toUpperCase();
                        break;
                    case this.case.PARCELA_SIGEF:
                        arquivoNome = resultado.valorConsulta;
                        break;
                    case this.case.ARQUIVO:
                        documento = `[${JSON.stringify(resultado.geoJson)}]`;
                        arquivoNome = resultado.valorConsulta;
                        break;
                    case this.case.GEOMETRIA:
                        break;
                    case this.case.CPF_CNPJ:
                        documento = formatters.cpfCnpjFormatToNumeral(
                            resultado.valorConsulta
                        );
                        break;
                    default:
                        break;
                }

                const dadosGerarPdf = {
                    tipoDocumento:
                        resultado.tipo === 'ARQUIVO'
                            ? 'GEOMETRIA'
                            : resultado.tipo,
                    documento,
                    camadas: this.camadasAtivas,
                    buffer: null,
                    nomeArquivo: arquivoNome
                };

                retryOperation(
                    DiagnosticoSocioambientalService.exportarPdf,
                    [dadosGerarPdf],
                    5000,
                    10
                );
            } catch (error) {
                resultado.loadingDownloadPdf = true;
                this.$notify.error({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.erro.naoFoiPossivelExportarPdf'
                    )
                });
                disconnect();
            }
        },

        /**
         * Realiza o download do PDF
         * a partir dos dados do diagnóstico
         * socioambiental mais os dados
         * de proximidade que foi clicado
         *
         * @param {*} resultado
         */
        async exportarPdfComAnaliseProximidade(resultado) {
            this.visible = false;
            try {
                await connect();
                resultado.loadingDownloadPdfComAnaliseProximidade = true;

                this.adicionarSubscribeDownloadPdf(resultado);

                let documento;

                switch (resultado.tipo) {
                    case 'CODIGOCAR':
                        documento = resultado.valorConsulta.toUpperCase();
                        break;
                    case 'ARQUIVO':
                        documento = `[${JSON.stringify(resultado.geoJson)}]`;
                        break;
                    case 'GEOMETRIA':
                        // documento = JSON.stringify([
                        //     this.geometriaSigef
                        //         ? this.geometriaSigef
                        //         : this.geometriaDesenhadaAcao
                        // ]);
                        break;
                    case 'CPF_CNPJ':
                        documento = formatters.cpfCnpjFormatToNumeral(
                            resultado.valorConsulta
                        );
                        break;
                    default:
                        break;
                }

                // se possui analise de proximidade
                const analiseProximidade = resultado.diagnosticoProximidade
                    ? JSON.stringify(resultado.diagnosticoProximidade.geometria)
                    : null;

                const dadosGerarPdf = {
                    tipoDocumento:
                        resultado.tipo === 'ARQUIVO'
                            ? 'GEOMETRIA'
                            : resultado.tipo,
                    documento,
                    camadas: this.camadasAtivas,
                    buffer: analiseProximidade,
                    nomeArquivo: null
                };

                retryOperation(
                    DiagnosticoSocioambientalService.exportarPdf,
                    [dadosGerarPdf],
                    5000,
                    10
                );
            } catch (error) {
                resultado.loadingDownloadPdfComAnaliseProximidade = true;
                this.$notify.error({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.erro.naoFoiPossivelExportarPdf'
                    )
                });
                disconnect();
            }
        },

        /**
         * Subscribe do websocket
         * do download do pdf
         *
         * @param {*} resultado
         */
        adicionarSubscribeDownloadPdf(resultado) {
            subscribe(
                `${this.usuarioLogado.idKeyCloack}/exportar/pdf/diagnostico/socio`,
                response => {
                    if (response) {
                        const linkSource = `data:application/pdf;base64,${response}`;
                        const link = document.createElement('a');
                        const fileName = 'diagnosticos-socioambientais.pdf';

                        const currentDate = new Date();
                        const formattedDate = `${currentDate.getFullYear()}${String(
                            currentDate.getMonth() + 1
                        ).padStart(2, '0')}${String(
                            currentDate.getDate()
                        ).padStart(2, '0')}`;
                        const formattedTime = `${String(
                            currentDate.getHours()
                        ).padStart(2, '0')}${String(
                            currentDate.getMinutes()
                        ).padStart(2, '0')}${String(
                            currentDate.getSeconds()
                        ).padStart(2, '0')}`;

                        const newFileName = fileName.replace(
                            '.pdf',
                            `-${formattedDate}-${formattedTime}.pdf`
                        );

                        link.href = linkSource;
                        link.download = newFileName;
                        link.click();
                        link.remove();
                    } else {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.diagnosticoSocioambiental.erro.naoFoiPossivelExportarPdf'
                            )
                        });
                    }
                    resultado.loadingDownloadPdf = false;
                    resultado.loadingDownloadPdfComAnaliseProximidade = false;
                    disconnect();
                }
            );
        },
        async buscarFincaPadronParaguai() {
            this.mostrarModalModalSelecionarDadosFincaPadron = true;
        },
        async processamentoParaguai(valorConsulta, geoJson, conteudo = null) {
            if (!valorConsulta) return;

            this.listaArquivosUpload = [];

            let caseSelecionado = this.case.FINCA_PADRON;
            if (geoJson) {
                caseSelecionado = this.case.ARQUIVO;
            }

            this.loadingProcessamento = true;

            switch (caseSelecionado) {
                case this.case.FINCA_PADRON:
                    try {
                        const { data } =
                            await TerritorioService.buscarTerritorioPorFincaOrPadron(
                                valorConsulta,
                                this.departamentoSelecionado.code,
                                this.distritoSelecionado.code
                            );
                        if (data.finca.data.length === 0) {
                            this.$notify.error({
                                message: this.$t(
                                    'mensagens.diagnosticoSocioambiental.consultaNaoEncontrada'
                                )
                            });
                            break;
                        }
                        this.dataFincaPadron = data.finca.data;
                        this.buscarFincaPadronParaguai();
                    } catch {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.diagnosticoSocioambiental.consultaNaoEncontrada'
                            )
                        });
                    }
                    break;
                case this.case.ARQUIVO:
                    await this.adicionarProcessamentoAposModalFincaPadron({
                        geometria: geoJson,
                        distrito: valorConsulta,
                        caseSelecionado
                    });
                    break;
                default:
                    this.$notify.error({
                        message:
                            'Tipo de Diagnóstico Socioambiental não implementado.'
                    });
                    break;
            }

            this.loadingProcessamento = false;
        },

        async adicionarProcessamentoAposModalFincaPadron({
            geometria,
            distrito,
            caseSelecionado
        }) {
            this.mostrarModalModalSelecionarDadosFincaPadron = false;

            let loadingRequest = true;
            const idRequest = uuid.v1();
            const jsonTransformadoEmString = JSON.stringify(geometria);
            const valorSelecionadoConsulta =
                caseSelecionado === this.case.ARQUIVO
                    ? distrito
                    : `${this.consultaDiagnosticoSocioambiental} - ${distrito}`;

            let envelope = {
                idRequest,
                valorConsulta: valorSelecionadoConsulta,
                conteudo: valorSelecionadoConsulta,
                loading: loadingRequest,
                geoJson: geometria,
                tipo: caseSelecionado,
                erro: false,
                informacoesGerais: null,
                podeRealizarAnaliseProximidade: false,
                loadingDownloadPdf: false,
                loadingDownloadPdfComAnaliseProximidade: false,
                idDiagnosticoSocioambiental: 0,
                diagnosticoProximidade: null
            };

            // limpar campo de busca
            this.consultaDiagnosticoSocioambiental = null;
            this.departamentoSelecionado = null;
            this.distritoSelecionado = null;

            // remove arquivo
            // TODO: melhorar isso
            this.onRemoveFile();

            if (this.resultadosDiagnosticosSocioambientais.length === 0) {
                this.resultadosDiagnosticosSocioambientais = {};
            }

            this.$set(
                this.resultadosDiagnosticosSocioambientais,
                idRequest,
                envelope
            );

            try {
                const { data } =
                    await DiagnosticoSocioambientalService.consultarSocioambientalPY(
                        jsonTransformadoEmString,
                        idRequest
                    );
                let resultadoDiagnostico = this.ordenarFiltrarCustomizar(
                    data.dataCAR,
                    null,
                    data.documento
                );
                const itemIndex = data.idRequest;

                this.resultadosDiagnosticosSocioambientais[
                    itemIndex
                ].diagnosticos = resultadoDiagnostico;
                this.resultadosDiagnosticosSocioambientais[
                    itemIndex
                ].loading = false;

                if (data.informacoes_gerais) {
                    this.resultadosDiagnosticosSocioambientais[
                        itemIndex
                    ].informacoesGerais = data.informacoes_gerais;
                }

                if (data.produtividade) {
                    this.resultadosDiagnosticosSocioambientais[
                        itemIndex
                    ].produtividade = data.produtividade;
                }

                if (geometria) {
                    this.resultadosDiagnosticosSocioambientais[
                        itemIndex
                    ].geoJson = geometria;
                }

                if (
                    this.resultadosDiagnosticosSocioambientais[itemIndex]
                        .geoJson
                ) {
                    this.resultadosDiagnosticosSocioambientais[
                        itemIndex
                    ].podeRealizarAnaliseProximidade = true;
                }

                if (data.idDiagnosticoSocioambiental) {
                    this.resultadosDiagnosticosSocioambientais[
                        itemIndex
                    ].idDiagnosticoSocioambiental =
                        data.idDiagnosticoSocioambiental;
                }

                loadingRequest = false;

                // Atualiza o envelope com loadingRequest = false
                envelope = {
                    ...envelope,
                    loading: loadingRequest
                };

                this.$set(
                    this.resultadosDiagnosticosSocioambientais,
                    idRequest,
                    envelope
                );
            } catch (error) {
                if (error && error.config && error.config.url) {
                    const url = error.config.url;
                    const regex =
                        /([a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12})/;
                    const matches = url.match(regex);

                    if (matches && matches.length > 1) {
                        const idRequest = matches[1];
                        const item = Object.values(
                            this.resultadosDiagnosticosSocioambientais
                        ).find(r => r.idRequest === idRequest);
                        item.loading = false;
                        item.erro = true;
                    }
                }
            }

            this.mostrarModalModalSelecionarDadosFincaPadron = false;
        },

        /**
         * Ao abrir ou fechar o collapse
         * do Diagnóstico Socioambiental
         * do primeiro nível
         *
         */
        abrirFecharCollapsesPrimeiroNivel() {
            const filtrado = this.indexCollapseAgrupado.filter(f => f !== '');
            if (filtrado.length) {
                if (this.collapsePrincipalAbertos.length) {
                    if (
                        filtrado.length > this.collapsePrincipalAbertos.length
                    ) {
                        // quando é a adição de um novo
                        const diferentes = filtrado.filter(
                            elemento =>
                                !this.collapsePrincipalAbertos.includes(
                                    elemento
                                )
                        );
                        this.adicionarRemoverGeometriaPrincipalNoMpa(
                            diferentes[0]
                        );
                        this.collapsePrincipalAbertos = filtrado;
                    } else {
                        // quando é a remoção
                        const diferentesRemocao =
                            this.collapsePrincipalAbertos.filter(
                                elemento => !filtrado.includes(elemento)
                            );
                        if (diferentesRemocao.length) {
                            this.$refs[
                                'refDiagnosticoSocioambiental' +
                                    diferentesRemocao[0]
                            ][0].fecharCollapses();

                            this.layersMaps = this.layersMaps.filter(
                                l => l.indexDiagnostico !== diferentesRemocao[0]
                            );

                            this.layersMaps = this.layersMaps.filter(
                                l =>
                                    l.name !==
                                    `AnaliseProximidade-${diferentesRemocao[0]}-100`
                            );

                            this.collapsePrincipalAbertos =
                                this.collapsePrincipalAbertos.filter(
                                    c => c !== diferentesRemocao[0]
                                );

                            // fechar e remover do mapa todas as restricoes de proximidade
                            this.abrirFecharCollapsesRestricoesProximidade(
                                diferentesRemocao[0] + '-100',
                                []
                            );
                        }
                    }
                } else {
                    // quando é o primeiro
                    this.collapsePrincipalAbertos = filtrado;
                    this.adicionarRemoverGeometriaPrincipalNoMpa(filtrado[0]);
                }
            } else {
                // quando é o último
                this.$refs[
                    'refDiagnosticoSocioambiental' +
                        this.collapsePrincipalAbertos[0]
                ][0].fecharCollapses();

                const proximidade =
                    this.$refs[
                        'refDiagnosticoSocioambientalProximidades-' +
                            this.collapsePrincipalAbertos[0] +
                            '-100'
                    ];

                if (proximidade?.length) {
                    proximidade[0].fecharCollapses();
                }

                this.removerTodasGeometriasDoMapa();
                this.collapsePrincipalAbertos = [];
                this.collapseProximidadeRestricoesAbertas = [];
            }
        },

        /**
         * Ao abrir ou fechar o collapse das restrições
         *
         * @param {*} indexCollapse index do collapse do DS clicado
         * @param {*} indexRestricao index do collapse da restrição clicada
         */
        abrirFecharCollapsesRestricoes(indexDiagnostico, indexRestricao) {
            const filtrado = indexRestricao.filter(f => f !== '');

            if (filtrado.length) {
                if (
                    this.collapsePrincipalRestricoesAbertas[indexDiagnostico]
                        ?.length
                ) {
                    if (
                        filtrado.length >
                        this.collapsePrincipalRestricoesAbertas[
                            indexDiagnostico
                        ].length
                    ) {
                        this.collapsePrincipalRestricoesAbertas[
                            indexDiagnostico
                        ] = filtrado;
                    } else {
                        const diferentes =
                            this.collapsePrincipalRestricoesAbertas[
                                indexDiagnostico
                            ].filter(elemento => !filtrado.includes(elemento));
                        if (diferentes.length) {
                            this.layersMaps = this.layersMaps.filter(
                                l =>
                                    l.group !==
                                    `grupo-restricoes-${indexDiagnostico}-${diferentes[0]}`
                            );
                            this.layersMaps = this.layersMaps.filter(
                                l =>
                                    l.group !==
                                    `grupo-centroid-${indexDiagnostico}-${diferentes[0]}`
                            );
                            this.collapsePrincipalRestricoesAbertas[
                                indexDiagnostico
                            ] = this.collapsePrincipalRestricoesAbertas[
                                indexDiagnostico
                            ].filter(r => r !== diferentes[0]);
                        }
                    }
                } else {
                    this.collapsePrincipalRestricoesAbertas[indexDiagnostico] =
                        filtrado;
                }
            } else {
                this.layersMaps = this.layersMaps.filter(
                    l =>
                        l.group !==
                        `grupo-restricoes-${indexDiagnostico}-${this.collapsePrincipalRestricoesAbertas[indexDiagnostico]}`
                );

                this.layersMaps = this.layersMaps.filter(
                    l =>
                        l.group !==
                        `grupo-centroid-${indexDiagnostico}-${this.collapsePrincipalRestricoesAbertas[indexDiagnostico]}`
                );

                this.collapsePrincipalRestricoesAbertas = [];
            }
        },

        /**
         * Ao abrir ou fechar o collapse das restrições de proximidade
         *
         * @param {*} indexDiagnostico
         * @param {*} indexRestricao
         */
        abrirFecharCollapsesRestricoesProximidade(
            indexDiagnosticoProximidade,
            indexRestricao
        ) {
            const filtrado = indexRestricao.filter(f => f !== '');

            if (filtrado.length) {
                if (
                    this.collapseProximidadeRestricoesAbertas[
                        indexDiagnosticoProximidade
                    ]?.length
                ) {
                    if (
                        filtrado.length >
                        this.collapseProximidadeRestricoesAbertas[
                            indexDiagnosticoProximidade
                        ].length
                    ) {
                        this.collapseProximidadeRestricoesAbertas[
                            indexDiagnosticoProximidade
                        ] = filtrado;
                    } else {
                        const diferentes =
                            this.collapseProximidadeRestricoesAbertas[
                                indexDiagnosticoProximidade
                            ].filter(elemento => !filtrado.includes(elemento));
                        if (diferentes.length) {
                            this.layersMaps = this.layersMaps.filter(
                                l =>
                                    l.group !==
                                    `grupo-restricoes-${indexDiagnosticoProximidade}-${diferentes[0]}`
                            );
                            this.layersMaps = this.layersMaps.filter(
                                l =>
                                    l.group !==
                                    `grupo-centroid-${indexDiagnosticoProximidade}-${diferentes[0]}`
                            );

                            this.collapseProximidadeRestricoesAbertas =
                                this.collapseProximidadeRestricoesAbertas.filter(
                                    c => c !== diferentes[0]
                                );
                        }
                    }
                } else {
                    this.collapseProximidadeRestricoesAbertas[
                        indexDiagnosticoProximidade
                    ] = filtrado;
                }
            } else {
                const proximidade =
                    this.$refs[
                        'refDiagnosticoSocioambientalProximidades-' +
                            indexDiagnosticoProximidade
                    ];

                if (proximidade?.length) {
                    proximidade[0].fecharCollapses();
                }

                const indexDiagnosticoPrinciapl =
                    indexDiagnosticoProximidade.slice(0, -4);

                const analiseProximidade = this.layersMaps.find(
                    l =>
                        l.name ===
                        `AnaliseProximidade-${indexDiagnosticoProximidade}`
                );

                const analisePrincipal = this.layersMaps.find(
                    l =>
                        l.name ===
                        `collapse-agrupado-geometria-principal-${indexDiagnosticoPrinciapl}`
                );

                this.layersMaps = this.layersMaps.filter(
                    l => l.indexDiagnostico !== indexDiagnosticoProximidade
                );

                this.layersMaps = this.layersMaps.filter(
                    l => l.indexDiagnostico !== indexDiagnosticoPrinciapl
                );

                this.layersMaps = this.layersMaps.filter(
                    l =>
                        l.name !==
                        `AnaliseProximidade-${indexDiagnosticoProximidade}`
                );

                if (analiseProximidade) {
                    this.layersMaps.push(analiseProximidade);
                }

                if (analisePrincipal) {
                    this.layersMaps.push(analisePrincipal);
                }

                this.collapseProximidadeRestricoesAbertas = [];
            }
        },

        /**
         * Limpar as geometrias do DS e proximidade
         * por index de Diagnóstico Socioambiental
         * selecionado
         *
         * @param {*} indexDiagnostico index do collapse do DS clicado
         */
        limparGeometriasMapa(indexDiagnostico) {
            const indexDiagnosticoProximidade = indexDiagnostico + '-100';

            this.layersMaps = this.layersMaps.filter(
                l =>
                    l.indexDiagnostico !== indexDiagnostico &&
                    l.indexDiagnostico !== indexDiagnosticoProximidade &&
                    l.name !==
                        `AnaliseProximidade-${indexDiagnosticoProximidade}`
            );
        },

        /**
         * Adicionar ou remover geometrias principais(contorno) no mapa
         *
         * @param {*} index index do collapse do DS clicado
         */
        adicionarRemoverGeometriaPrincipalNoMpa(index) {
            const estaNoMapa = this.layersMaps.find(
                layer =>
                    layer.name ===
                    `collapse-agrupado-geometria-principal-${index}`
            );
            if (estaNoMapa) {
                // remove
                this.layersMaps = this.layersMaps.filter(
                    layer =>
                        layer.name !==
                        `collapse-agrupado-geometria-principal-${index}`
                );
            } else {
                // adiciona
                const { geoJson, tipo } =
                    this.resultadosDiagnosticosSocioambientais[index];

                if (geoJson) {
                    const style = tipo === 'CODIGOCAR' ? 'car' : 'area';
                    const collapseMultiplosGeometriaPrincipal = {
                        indexDiagnostico: index,
                        name: `collapse-agrupado-geometria-principal-${index}`,
                        style: getEstiloGeometria(style),
                        geoJson
                    };
                    this.layersMaps.push(collapseMultiplosGeometriaPrincipal);
                }
            }

            const diagnostico =
                this.resultadosDiagnosticosSocioambientais[index];

            if (diagnostico?.diagnosticoProximidade) {
                const indexProximidade = index + '-100';
                const proximidadeEstaNoMapa = this.layersMaps.find(
                    layer =>
                        layer.name === `AnaliseProximidade-${indexProximidade}`
                );

                if (proximidadeEstaNoMapa) {
                    // remove
                    this.layersMaps = this.layersMaps.filter(
                        layer =>
                            layer.name !==
                            `AnaliseProximidade-${indexProximidade}`
                    );
                } else {
                    // adiciona
                    this.layersMaps.push({
                        style: getEstiloGeometria('area'),
                        name: 'AnaliseProximidade-' + indexProximidade,
                        geoJson: diagnostico.diagnosticoProximidade.geometria
                    });
                }
            }
        },

        removerTodasGeometriasDoMapa() {
            this.layersMaps = [];
        },
        iniciarPopoverInterno(index) {
            this.$set(this.visible, index, false);
        },
        ativarPopoverInterno(index) {
            this.$set(this.visible, index, !this.visible[index]);
        },
        iniciarPopoverMarcarParaPDF(index) {
            this.$set(this.visiblePopoverMarcarParaPDF, index, false);
        },
        resetarPopoverAcoes() {
            if (Array.isArray(this.visible)) {
                this.visible = this.visible.map(() => false);
            } else {
                this.visible = [];
            }

            if (Array.isArray(this.visiblePopoverMarcarParaPDF)) {
                this.visiblePopoverMarcarParaPDF =
                    this.visiblePopoverMarcarParaPDF.map(() => false);
            } else {
                this.visiblePopoverMarcarParaPDF = [];
            }
        },
        marcarExportacaoDiagnosticPdf(item) {
            let documento = {};

            switch (item.tipo) {
                case this.case.CODIGOCAR:
                    documento.value = item.valorConsulta.toUpperCase();
                    documento.nome = 'CAR ' + item.valorConsulta;
                    break;
                case this.case.ARQUIVO:
                    documento.value = `[${JSON.stringify(item.geoJson)}]`;
                    documento.nome = item.valorConsulta;
                    break;
                case this.case.GEOMETRIA:
                    break;
                case this.case.CPF_CNPJ:
                    documento.value = formatters.cpfCnpjFormatToNumeral(
                        item.valorConsulta
                    );
                    documento.nome =
                        'CPF/CNPJ ' +
                        formatters.cpfCnpjFormatToNumeral(item.valorConsulta);
                    break;
                default:
                    break;
            }

            documento.type = item.tipo;

            let camadasPdf = this.camadasAtivas;

            let tipoDocumento = item.tipo;

            if (item.tipo === this.case.ARQUIVO) {
                tipoDocumento = 'GEOMETRIA';
            }

            const params = {
                idLista: Math.floor(Date.now() * Math.random()).toString(36),
                idTerritorio: null,
                tipoDocumento,
                documento: documento.value,
                camadas: camadasPdf,
                nome: documento.nome,
                buffer: null,
                nomeArquivo: null
            };

            this.setMarcarExportar_PDF(params);
        },
        marcarExportacaoDiagnosticPdfProximidade(item) {
            let documento = {};

            switch (item.tipo) {
                case this.case.CODIGOCAR:
                    documento.value = item.valorConsulta.toUpperCase();
                    documento.nome = 'CAR ' + item.valorConsulta;
                    break;
                case this.case.ARQUIVO:
                    documento.value = `[${JSON.stringify(item.geoJson)}]`;
                    documento.nome = item.valorConsulta;
                    break;
                case this.case.GEOMETRIA:
                    break;
                case this.case.CPF_CNPJ:
                    documento.value = formatters.cpfCnpjFormatToNumeral(
                        item.valorConsulta
                    );
                    documento.nome =
                        'CPF/CNPJ ' +
                        formatters.cpfCnpjFormatToNumeral(item.valorConsulta);
                    break;
                default:
                    break;
            }

            documento.type = item.tipo;

            let camadasPdf = this.camadasAtivas;

            let tipoDocumento = item.tipo;

            if (item.tipo === this.case.ARQUIVO) {
                tipoDocumento = 'GEOMETRIA';
            }

            const params = {
                idLista: Math.floor(Date.now() * Math.random()).toString(36),
                idTerritorio: null,
                tipoDocumento,
                documento: documento.value,
                camadas: camadasPdf,
                nome: 'Prox: ' + documento.nome,
                buffer: item.diagnosticoProximidade
                    ? JSON.stringify(item.diagnosticoProximidade.geometria)
                    : null,
                nomeArquivo: null
            };

            this.setMarcarExportar_PDF(params);
        },
        realizarDiagnosticoSocioAmbientalPeloMapa(geometriaAcao) {
            if (this.validarConsulta(JSON.stringify(geometriaAcao))) {
                this.nomeGeometriaDesenhada++;
                const nomeGeometria =
                    'Geometria ' + this.nomeGeometriaDesenhada;

                if (
                    this.usuarioLogado.ambienteLogado ===
                    this.ambientes.PARAGUAY
                ) {
                    this.processamentoParaguai(nomeGeometria, geometriaAcao);
                } else {
                    this.adicionarProcessamento(
                        nomeGeometria,
                        geometriaAcao,
                        JSON.stringify(geometriaAcao)
                    );
                }
            }
        },
        handleScroll() {
            this.resetarPopoverAcoes();
        },
        aplicarZoomGeometria(resultado) {
            if (resultado.geoJson) {
                this.refMapa.aplicarZoomGeoJson(resultado.geoJson);
            }
        },
        abrirModalDiagnosticoSociambientalEmLote() {
            this.mostrarModalDiagnosticoSociambientalEmLote = true;
        },
        toggleCollapse() {
            this.isCollapsed = !this.isCollapsed;
            setTimeout(() => this.$refs.mapa.refreshMap(), 300);
        },
        async buscarGeometriaTerritorio() {
            const response = await TerritorioService.findById(
                this.idTerritorio
            );
            this.adicionarProcessamento(
                response.data.nome,
                response.data.geometria
            );
        },
        orderName(a, b) {
            const nameA = a.label.toUpperCase();
            const nameB = b.label.toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        },
        async listarLocalidadeNivelUm() {
            this.departamento.loading = true;

            try {
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelUm();
                const dataFormat = data
                    .map(item => {
                        return {
                            label: item.nome,
                            code: item.codigo,
                            id: item.id
                        };
                    })
                    .sort((a, b) => this.orderName(a, b));

                this.departamento.lista = dataFormat;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelUm'
                    )
                });
            } finally {
                this.departamento.loading = false;
            }
        },

        async listarLocalidadeNivelDois() {
            this.distrito.loading = true;
            this.distritoSelecionado = null;

            try {
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelDois(
                        this.departamentoSelecionado.id
                    );
                const dataFormat = (data || [])
                    .map(item => ({
                        label: item?.nome ?? '',
                        code: (item?.codigo ?? '').toString().replace(/[^\d]/g, ''),
                        id: item?.id
                    }))
                    .sort((a, b) => this.orderName(a, b));
                this.distrito.lista = dataFormat;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelDois'
                    )
                });
            } finally {
                this.distrito.loading = false;
            }
        }
    }
};
</script>

<style lang="scss">
#ds-multiplos {
    padding: 20px;
    height: 100%;
    width: 100%;
    display: flex;
    border-radius: 4px;

    .ds-multiplos-card {
        @include scroll-bar();
        display: flex;
        flex-direction: column;
        background-color: var(--white);
        border: 0;
        border-radius: 5px 0 0 5px;
        transition: width 0s ease;

        .ds-multiplos-card-header-1 {
            margin-bottom: 20px;
        }

        .ds-multiplos-card-header-2 {
            height: 78px;
        }

        .ds-multiplos-card-header {
            .ds-multiplos-card-header__titulo {
                font-size: 20px;
                font-weight: bold;
                display: flex;
                justify-content: space-between;
                padding-right: 10px;

                .el-icon-arrow-left,
                .el-icon-arrow-right {
                    cursor: pointer;
                }
            }

            .el-icon-arrow-right {
                position: absolute;
                left: 120px;
                font-size: 30px;
                z-index: 1000;
            }

            .ds-multiplos-card-header__subtitulo {
                font-weight: bold;
                color: var(--primary-font-color);
                font-size: 13px;
                margin-left: 10px;

                .ds-multiplos-card-header-subtitulo {
                    display: flex;
                    justify-content: space-between;
                    margin-right: 27px;

                    .ds-multiplos-card-header-subtitulo__titulo {
                        display: flex;
                        justify-content: center;
                        flex-direction: row;
                        align-items: center;
                        gap: 5px;
                    }

                    .ds-multiplos-card-header-subtitulo__acoes {
                        display: flex;
                        justify-content: space-between;
                        gap: 10px;
                    }
                }
            }
        }

        .ds-multiplos-card--scroll {
            display: flex;
            flex-direction: column;
            gap: 20px;
            padding-right: 10px;
            margin-bottom: 10px;

            .ds-multiplos-card-campo-consulta {
                display: flex;
                flex-direction: column;
                gap: 5px;

                .ds-multiplos-card-campo-consulta__input {
                    display: flex;
                    flex-direction: row;
                    gap: 10px;
                    button:disabled {
                        cursor: not-allowed;
                    }
                }
            }
        }

        .ds-multiplos-card-resultado--scroll {
            display: flex;
            flex-direction: column;
            padding-right: 10px;
            overflow: auto;
            height: 100%;

            .ds-multiplos-card-lista-resultado_titulo {
                font-size: 16px;
                font-weight: bold;
                margin: 16px 0 8px;
            }

            .ds-multiplos-card-resultado__collapse {
                display: flex;
                flex-direction: column;
                gap: 10px;

                .ds-multiplos-card-resultado__item {
                    border: 1px solid #dddede;
                    border-radius: 5px;
                    padding: 10px;

                    .ds-multiplos-card-resultado__deletar {
                        margin-right: 5px;
                    }

                    .ds-multiplos-card-resultado__valor-consultado {
                        font-weight: bold;
                        color: var(--primary-font-color);
                        font-size: 14px;
                    }

                    .ds-multiplos-card-resultado-informacoes-gerais {
                        display: flex;
                        flex-direction: column;
                        gap: 5px;

                        .el-divider--horizontal {
                            display: block;
                            height: 1px;
                            width: 100%;
                            margin: 0px 0;
                        }

                        .ds-multiplos-card-resultado-informacoes-gerais__titulo {
                            font-size: 14px;
                            font-weight: bold;
                            color: var(--primary-font-color);
                        }

                        .ds-multiplos-card-resultado-informacoes-gerais__linha {
                            display: grid;
                            gap: 20px;
                        }

                        .ds-multiplos-card-resultado-informacoes-gerais__item {
                            display: flex;
                            flex-direction: column;
                            flex: 1;

                            label {
                                font-weight: bold;
                                color: var(--primary-font-color);
                                white-space: nowrap;
                            }
                        }
                    }

                    .ds-multiplos-card-resultado {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 20px;
                        gap: 10px;

                        .ds-multiplos-card-resultado__titulo {
                            span {
                                font-weight: bold;
                                color: var(--primary-font-color);
                                font-size: 14px;
                                margin-left: 10px;
                            }

                            .el-icon-finished {
                                font-size: 16px;
                                font-weight: bold;
                            }
                        }

                        .ds-multiplos-card-resultado__acoes {
                            display: flex;
                            justify-content: space-between;
                            gap: 10px;
                        }
                    }

                    .ds-multiplos-card-resultado-proximidade {
                        background-color: #d7dada42;
                        padding: 5px;
                        border-radius: 5px;
                        margin: 10px 0px;

                        i {
                            font-size: 16px;
                            font-weight: bold;
                        }

                        span {
                            font-size: 14px;
                            font-weight: bold;
                            color: var(--primary-font-color);
                            margin-left: 10px;
                        }
                    }
                }

                .el-collapse-item__wrap {
                    border: 0;
                }
            }
        }
    }

    @media (max-width: 900px) {
        #ds-multiplos {
            flex-direction: column;
        }

        .ds-multiplos-card {
            height: 400px;
            width: 100%;

            .vazio {
                height: 60px;
            }
        }
    }

    #mapaDiagnosticoSocioambiental {
        border-radius: 0 5px 5px 0;
    }
}

.ds-multiplos-card-resultado-acoes__exportar {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
}

.el-icon-loading {
    color: #ffd700 !important;
}

.icone i {
    font-size: 12px !important;
}

.button-container {
    display: flex;
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;

    .button-lote,
    .remover-todos {
        margin: 0;
    }
}

.width-58-percent {
    width: 45%;
}

.width-30-percent {
    width: 0%;
}
</style>
